import axios from 'axios';
import TopBar from 'components/Layout/TopBar';
import React, { useEffect, useState } from 'react';
import { useAlert } from 'react-alert';
import { useNavigate } from 'react-router';
import { ClipLoader } from 'react-spinners';
import useAuthz from '../../hooks/useAuthz';
import { URL_API } from '../../utils/globalConfig';
import { logError, transformDatas } from '../../components/Utils/FormatData';
import MyForm from '../../components/Layout/MyForm';
import MyButton from '../../components/Layout/MyButton';
import { faCheck, faXmark } from '@fortawesome/free-solid-svg-icons';
import { PROFIL } from '../../constants/enum';

const CreateOrEditUtilisateur = (props) => {
  const user_id = new URLSearchParams(location.search).get('id');
  const [isLoading, setIsLoading] = useState(true);
  const [formIsValid, setFormValid] = useState(true);
  const [profils, setProfils] = useState(null);
  const [centres, setCentres] = useState(null);
  const [userDetail, setUserDetail] = useState({
    num_cerfa: null,
    num_siren: null,
    num_tva: null,
    new_password_1: null,
    new_password_2: null,
    raison_sociale: null,
    adresse: null,
    complement_adresse: null,
    code_postal: null,
    commune: null,
    pays: null,
    telephone_1: null,
    telephone_2: null,
    fax: null,
    email: null,
    id_profil: 6,
    centers: [],
  });
  const navigate = useNavigate();
  const [authz, user, profil] = useAuthz();
  const alert = useAlert();
  const routeUtilisateurs = '/panneau-administration/utilisateur';

  useEffect(() => {
    if (userDetail.id_profil < 5 && user_id) {
      fetchUserCenters();
    }
  }, [userDetail.id_profil]);

  const formInterne = [{
    id: 'id_profil',
    name: 'id_profil',
    label: 'TYPE PROFIL',
    type: 'select',
    options: profils,
    disabled: false,
    displayLabel: true,
    labelClass: 'select-label-black',
    value: userDetail.id_profil,
    multiple: false,
    disableClass: true,
    formControlStyle: { width: '100%'},
  }, {
    id: 'login',
    name: 'login',
    label: 'LOGIN',
    type: 'text',
    required: true,
    readOnly: false,
    style: { width: '100%', margin: '20px' },
  }, {
    id: 'email',
    name: 'email',
    label: 'EMAIL',
    type: 'text',
    required: true,
    readOnly: false,
    style: { width: '100%', margin: '20px' },
  }, {
    id: 'nom',
    name: 'nom',
    label: 'NOM',
    type: 'text',
    required: true,
    readOnly: false,
    style: { width: '100%', margin: '20px' },
  }, {
    id: 'prenom',
    name: 'prenom',
    label: 'PRÉNOM',
    type: 'text',
    required: true,
    readOnly: false,
    style: { width: '100%', margin: '20px' },
  }, {
    id: 'adresse',
    name: 'adresse',
    label: 'ADRESSE',
    type: 'text',
    required: false,
    readOnly: false,
    style: { width: '100%', margin: '20px' },
  }, {
    id: 'complement_adresse',
    name: 'complement_adresse',
    label: 'COMPLÉMENT ADRESSE',
    type: 'text',
    required: false,
    readOnly: false,
    style: { width: '100%', margin: '20px' },
  }, {
    id: 'code_postal',
    name: 'code_postal',
    label: 'CODE POSTAL',
    type: 'text',
    required: false,
    readOnly: false,
    style: { width: '100%', margin: '20px' },
  }, {
    id: 'commune',
    name: 'commune',
    label: 'COMMUNE',
    type: 'text',
    required: false,
    readOnly: false,
    style: { width: '100%', margin: '20px' },
  }, {
    id: 'pays',
    name: 'pays',
    label: 'PAYS',
    type: 'text',
    required: false,
    readOnly: false,
    style: { width: '100%', margin: '20px' },
  }, {
    id: 'telephone_1',
    name: 'telephone_1',
    label: 'N° TÉLÉPHONE',
    type: 'text',
    required: false,
    readOnly: false,
    style: { width: '100%', margin: '20px' },
  }, {
    id: 'telephone_2',
    name: 'telephone_2',
    label: 'N° TÉLÉPHONE 2',
    type: 'text',
    required: false,
    readOnly: false,
    style: { width: '100%', margin: '20px' },
  }, {
    id: 'fax',
    name: 'fax',
    label: 'FAX',
    type: 'text',
    required: false,
    readOnly: false,
    style: { width: '100%', margin: '20px' },
  }, {
    id: 'centers',
    name: 'centers',
    label: 'CENTRE',
    type: 'select',
    value: userDetail.centers ?? [],
    options: centres,
    disabled: false,
    displayLabel: true,
    labelClass: 'select-label-black',
    multiple: true,
    disableClass: true,
    formControlStyle: { width: '100%'}
  }];
  const formExterneEdit = [{
    id: 'id_profil',
    name: 'id_profil',
    label: 'TYPE PROFIL',
    type: 'select',
    options: profils,
    disabled: false,
    displayLabel: true,
    labelClass: 'select-label-black',
    value: userDetail.id_profil,
    multiple: false,
    disableClass: true,
    formControlStyle: { width: '100%'},
  }, {
    id: 'email',
    name: 'email',
    label: 'EMAIL',
    type: 'text',
    required: true,
    readOnly: false,
    style: { width: '100%', margin: '20px' },
  }, {
    id: 'new_password_1',
    name: 'new_password_1',
    label: 'NOUVEAU MOT DE PASSE',
    type: 'password',
    required: false,
    readOnly: false,
    style: { width: '100%', margin: '20px' },
  }, {
    id: 'new_password_2',
    name: 'new_password_2',
    label: 'NOUVEAU MOT DE PASSE',
    type: 'password',
    required: false,
    readOnly: false,
    style: { width: '100%', margin: '20px' },
  }, {
    id: 'num_siren',
    name: 'num_siren',
    label: 'N° SIRET',
    type: 'number',
    maxLength: 14,
    readOnly: false,
    style: { width: '100%', margin: '20px' },
  }, {
    id: 'num_tva',
    name: 'num_tva',
    label: 'N° TVA intracommunautaire',
    type: 'text',
    required: true,
    readOnly: false,
    style: { width: '100%', margin: '20px' },
  }, {
    id: 'raison_sociale',
    name: 'raison_sociale',
    label: 'RAISON SOCIALE',
    type: 'text',
    required: true,
    readOnly: false,
    style: { width: '100%', margin: '20px' },
  }, {
    id: 'adresse',
    name: 'adresse',
    label: 'ADRESSE',
    type: 'text',
    required: true,
    readOnly: false,
    style: { width: '100%', margin: '20px' },
  }, {
    id: 'complement_adresse',
    name: 'complement_adresse',
    label: 'COMPLÉMENT ADRESSE',
    type: 'text',
    required: false,
    readOnly: false,
    style: { width: '100%', margin: '20px' },
  }, {
    id: 'code_postal',
    name: 'code_postal',
    label: 'CODE POSTAL',
    type: 'text',
    required: true,
    readOnly: false,
    style: { width: '100%', margin: '20px' },
  }, {
    id: 'commune',
    name: 'commune',
    label: 'COMMUNE',
    type: 'text',
    required: true,
    readOnly: false,
    style: { width: '100%', margin: '20px' },
  }, {
    id: 'pays',
    name: 'pays',
    label: 'PAYS',
    type: 'text',
    required: true,
    readOnly: false,
    style: { width: '100%', margin: '20px' },
  }, {
    id: 'telephone_1',
    name: 'telephone_1',
    label: 'N° TÉLÉPHONE',
    type: 'text',
    required: false,
    readOnly: false,
    style: { width: '100%', margin: '20px' },
  }, {
    id: 'telephone_2',
    name: 'telephone_2',
    label: 'N° TÉLÉPHONE 2',
    type: 'text',
    required: false,
    readOnly: false,
    style: { width: '100%', margin: '20px' },
  }, {
    id: 'fax',
    name: 'fax',
    label: 'FAX',
    type: 'text',
    required: false,
    readOnly: false,
    style: { width: '100%', margin: '20px' },
  }];
  const formExterneCreate = [{
    id: 'id_profil',
    name: 'id_profil',
    label: 'TYPE PROFIL',
    type: 'select',
    options: profils,
    value: userDetail.id_profil,
    disabled: false,
    displayLabel: true,
    labelClass: 'select-label-black',
    multiple: false,
    disableClass: true,
    style: { width: '100%' },
    formControlStyle: { width: '100%'}
  }, {
    id: 'email',
    name: 'email',
    label: 'EMAIL',
    type: 'text',
    required: true,
    readOnly: false,
    style: { width: '100%', margin: '20px' },
  }, {
    id: 'num_siren',
    name: 'num_siren',
    label: 'N° SIRET',
    type: 'number',
    readOnly: false,
    maxLength: 14,
    style: { width: '100%', margin: '20px' },
  }, {
    id: 'num_tva',
    name: 'num_tva',
    label: 'N° TVA intracommunautaire',
    type: 'text',
    required: true,
    readOnly: false,
    style: { width: '100%', margin: '20px' },
  }, {
    id: 'raison_sociale',
    name: 'raison_sociale',
    label: 'RAISON SOCIALE',
    type: 'text',
    required: true,
    readOnly: false,
    style: { width: '100%', margin: '20px' },
  }, {
    id: 'adresse',
    name: 'adresse',
    label: 'ADRESSE',
    type: 'text',
    required: true,
    readOnly: false,
    style: { width: '100%', margin: '20px' },
  }, {
    id: 'complement_adresse',
    name: 'complement_adresse',
    label: 'COMPLÉMENT ADRESSE',
    type: 'text',
    required: false,
    readOnly: false,
    style: { width: '100%', margin: '20px' },
  }, {
    id: 'code_postal',
    name: 'code_postal',
    label: 'CODE POSTAL',
    type: 'text',
    required: true,
    readOnly: false,
    style: { width: '100%', margin: '20px' },
  }, {
    id: 'commune',
    name: 'commune',
    label: 'COMMUNE',
    type: 'text',
    required: true,
    readOnly: false,
    style: { width: '100%', margin: '20px' },
  }, {
    id: 'pays',
    name: 'pays',
    label: 'PAYS',
    type: 'text',
    required: true,
    readOnly: false,
    style: { width: '100%', margin: '20px' },
  }, {
    id: 'telephone_1',
    name: 'telephone_1',
    label: 'N° TÉLÉPHONE',
    type: 'text',
    required: false,
    readOnly: false,
    style: { width: '100%', margin: '20px' },
  }, {
    id: 'telephone_2',
    name: 'telephone_2',
    label: 'N° TÉLÉPHONE 2',
    type: 'text',
    required: false,
    readOnly: false,
    style: { width: '100%', margin: '20px' },
  }, {
    id: 'fax',
    name: 'fax',
    label: 'FAX',
    type: 'text',
    required: false,
    readOnly: false,
    style: { width: '100%', margin: '20px' },
  }];

  //#region useEffect

  useEffect(async () => {
    if (profil.profil === 1) {
      getProfilsList();
      apiGetListCenters();
      if (user_id) {
        document.title = 'TE - Editer un utilisateur';
        fetchLoadUser();
      } else {
        document.title = 'TE - Créer un utilisateur';
      }
      setIsLoading(false);
    } else {
      alert.error('Vous n\'êtes pas autorisé à accéder à ce module');
      navigate(routeUtilisateurs);
    }
  }, []);

  //#endregion

  //#region Fonctions

  const fetchLoadUser = () => {
    axios({ method: 'get', url: `${URL_API}/utilisateur/detail-id?id=${user_id}` })
      .then((response) => {
        setUserDetail({...userDetail, ...response.data});
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        alert.removeAll();
        alert.error(error?.response?.data?.message || "Une erreur est survenue, merci de contacter un administrateur");
      });
  };

  const fetchUserCenters = () => {
    axios({ method: 'get', url: `${URL_API}/localisation/centers-by-user?userId=${user_id}` })
      .then((response) => {
        setUserDetail({ ...userDetail, centers: response.data.map((c) => (c.id)) });
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        alert.removeAll();
        alert.error(error?.response?.data?.message || "Une erreur est survenue, merci de contacter un administrateur");
      });
  }

  const handleChangeValue = (event) => {
    setUserDetail({ ...userDetail, [event.target.name]: event.target.value });
  };
  const handleCancel = () => {
    navigate(routeUtilisateurs);
  };
  const handleValid = () => {
      if (userDetail.id_profil < 5) {
        if (!userDetail.email || !userDetail.login) {
          alert.error('Vous devez renseigner les champs requis avant de continuer');
          return false;
        }
      } else {
        if (!userDetail.email || !userDetail.num_tva || !userDetail.raison_sociale || !userDetail.adresse || !userDetail.code_postal || !userDetail.commune || !userDetail.pays) {
          alert.error('Vous devez renseigner les champs requis avant de continuer');
          return false;
        }

        if (userDetail.num_siren && userDetail.num_siren.length > 14) {
          alert.error('Le numéro SIREN doit contenir 14 caractères');
          return false;
        }
      }

    if (userDetail.new_password_1 !== userDetail.new_password_2) {
      alert.error('Les mots de passe ne sont pas identiques');
      return false;
    }
    if (userDetail.new_password_1 && userDetail.new_password_1.length < 12) {
      alert.error('Le mot de passe doit contenir au moins 12 caractères');
      return false;
    }
    if (userDetail.new_password_1 && !userDetail.new_password_1.match(/^(?=.*?[A-Z])(?=.*?[a-z])((?=.*?[0-9])|(?=.*?[#?!@$ %^&*-]))/)) {
      alert.error('Le mot de passe doit contenir au moins une majuscule, une minuscule et un chiffre ou un caractère spécial');
      return false;
    }

    if (user_id)
      editAccount();
    else
      createAccount();
  };
  const createAccount = () => {
    axios({
      method: 'post',
      url: `${URL_API}/utilisateur/inscription`,
      data: userDetail,
      params: { userAction: user.user_id },
    })
      .then(() => {
        alert.removeAll();
        alert.success('La création du compte a bien été effectuée ');
        navigate(routeUtilisateurs);
      })
      .catch((error) => {
        alert.removeAll();
        alert.error(error?.response?.data?.message || "Une erreur est survenue, merci de contacter un administrateur");
      });
  };
  const editAccount = () => {
    axios({
      method: 'post',
      url: `${URL_API}/utilisateur/edition`,
      data: userDetail,
      params: { userAction: user.user_id },
    })
      .then(() => {
        alert.removeAll();
        alert.success('L\'édition du compte a bien été effecutée ');
        navigate(routeUtilisateurs);
      })
      .catch((error) => {
        alert.removeAll();
        alert.error(error?.response?.data?.message || "Une erreur est survenue, merci de contacter un administrateur");
      });
  };
  const getProfilsList = () => {
    const promiseListeProfil = axios({ method: 'get', url: `${URL_API}/utilisateur/liste-profil` });

    Promise.all([promiseListeProfil])
      .then(function(values) {
        setProfils(values[0].data.map((p) => ({ ...p, label: p.type })));
        setIsLoading(false);
      })
      .catch(function(err) {
        logError(alert, err);
      });
  };

  const apiGetListCenters = () => {
    setIsLoading(true);
    axios({method: 'get', url: `${URL_API}/localisation/list-centers`})
      .then(function (response) {
        setCentres(response.data);
        setIsLoading(false);
      })
      .catch(function (err) {
        logError(alert, err);
        setIsLoading(false);
      });
  };

  //#endregion

  return (<div style={{ height: '100%' }}>
    <TopBar title={user_id ? 'Editer un utilisateur' : 'Créer un utilisateur'} className='topbar-contenu'
            color={props.params.color} buttons={null} />

    <div className='row'
         style={{ alignItems: isLoading ? 'center' : '', height: 'calc(100% - 50px)', overflow: 'auto' }}>
      <ClipLoader color='#0094ca' loading={isLoading} size={75}
                  css={'display: flex; margin: 25px;justify-content: center;'} />

      {!isLoading && (<div className='form-content-center' style={{ minWidth: 750 }}>
        {user_id ?
          <MyForm data={userDetail} variant={'outlined'} setData={setUserDetail}
                  form={userDetail.id_profil < 5 ? formInterne : formExterneEdit}
                  onChange={handleChangeValue} /> :
          <MyForm data={userDetail} variant={'outlined'} setData={setUserDetail}
                  form={userDetail.id_profil < 5 ? formInterne : formExterneCreate}
                  onChange={handleChangeValue} />}
        <div className='row' style={{ width: '100%', margin: '20px' }}>
          <MyButton onClick={handleCancel} style={'buttonDefault'} label={'Annuler'} icon={faXmark} />
          <MyButton onClick={handleValid} style={'buttonValidation'} label={'Valider'} icon={faCheck} />
        </div>
      </div>)}
    </div>
  </div>);
};

export default CreateOrEditUtilisateur;
